<template>
  <div class="dashboard-container">
    <div class="dashboard-header">
      <div class="dashboard-title">
        <!-- <h1>Expedientes</h1> -->
      </div>
      <div class="dashboard-actions">
        <button @click="toggleView" class="toggle-btn">
          <i :class="!isTableView ? 'fas fa-th-large' : 'fas fa-list'"></i>
          {{ !isTableView ? 'Vista de Tarjeta' : 'Vista de Tabla' }}
        </button>
        <button @click="openAddModal" class="add-btn" data-v-step="0">
          <i class="fas fa-plus"></i>
          Agregar Expediente
        </button>
        <button @click="startTour" class="help-btn" aria-label="Ayuda">
          <i class="fas fa-question-circle"></i>
        </button>
      </div>
    </div>
    <div class="search-container" data-v-step="1">
      <i class="fas fa-search search-icon"></i>
      <input type="text" v-model="searchQuery" class="search-input" placeholder="Buscar expediente por número o descripción...">
    </div>
    <div v-if="!proceedings.length" class="empty-state">
      <div class="empty-state-icon">
        <i class="fas fa-folder-open"></i>
      </div>
      <h3>Sin expedientes</h3>
      <p>Aún no has guardado ningún expediente. ¡Comienza añadiendo tu primer expediente!</p>
      <button @click="openAddModal" class="empty-state-btn">
        <i class="fas fa-plus"></i>
        Agregar Expediente
      </button>
    </div>
    <div v-else-if="isTableView && filteredProceedings.length > 0" class="cards-container">
      <div class="cards-grid">
        <div v-for="proceeding in filteredProceedings" :key="proceeding.id" class="proceeding-card" @click="openViewModal(proceeding.id)">
          <div class="card-header">
            <h3 class="card-title">{{ proceeding.number }}</h3>
            <div class="card-badge">
              <span class="badge-count">{{ proceeding.notifications.length }}</span>
              <i class="fas fa-bell"></i>
            </div>
          </div>
          <div class="card-body">
            <p class="card-description">{{ proceeding.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="filteredProceedings.length > 0" class="table-container" data-v-step="2">
      <table class="proceedings-table">
        <thead>
          <tr>
            <th>Expediente</th>
            <th>Descripción</th>
            <th>Notificaciones</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="proceeding in paginatedProceedings" :key="proceeding.id">
            <td>{{ proceeding.number }}</td>
            <td>{{ proceeding.description }}</td>
            <td>
              <span class="notification-badge" data-v-step="3">{{ proceeding.notifications.length }}</span>
            </td>
            <td>
              <button @click="openViewModal(proceeding.id)" class="table-btn view-btn" title="Ver detalles" data-v-step="4" >
                <i class="fas fa-eye"></i>
              </button>
              <button @click="openEditModal(proceeding.id)" class="table-btn edit-btn" title="Editar" data-v-step="5">
                <i class="fas fa-edit"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-container">
        <button @click="prevPage" class="pagination-btn prev-btn" :disabled="currentPage === 1">
          <i class="fas fa-chevron-left"></i>
        </button>
        <div class="pagination-info">
          <span>Página {{ currentPage }} de {{ totalPages }}</span>
        </div>
        <button @click="nextPage" class="pagination-btn next-btn" :disabled="currentPage === totalPages">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
    <div v-else-if="searchQuery && !filteredProceedings.length" class="empty-state">
      <div class="empty-state-icon">
        <i class="fas fa-search"></i>
      </div>
      <h3>No se encontraron resultados</h3>
      <p>No hay expedientes que coincidan con tu búsqueda "{{ searchQuery }}"</p>
      <button @click="searchQuery = ''" class="empty-state-btn">
        <i class="fas fa-times"></i>
        Limpiar búsqueda
      </button>
    </div>
    <AddProceedingModal v-if="showAdd" @close="showAdd = false" @saved="refreshProceedings" />
    <EditProceedingModal v-if="showEdit" :proceedingId="editId" @close="closeEditModal" @saved="refreshProceedings" />
    <ProceedingModal v-if="showView" :proceedingId="viewId" @close="closeViewModal" @edit="openEditModal" @deleted="refreshProceedings" />
        <v-tour name="myTour" :steps="steps" :options="myOptions"></v-tour>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import AddProceedingModal from '@/components/AddProceedingModal.vue';
import EditProceedingModal from '@/components/EditProceedingModal.vue';
import ProceedingModal from '@/components/ProceedingModal.vue';

export default defineComponent({
  name: 'ModernDashboardView',
  components: { AddProceedingModal, EditProceedingModal, ProceedingModal },
  data() {
    return {
      isTableView: false,
      searchQuery: '',
      currentPage: 1,
      itemsPerPage: 5,
      showAdd: false,
      showEdit: false,
      showView: false,
      editId: null,
      viewId: null,
            myOptions: {
          useKeyboardNavigation: false,
          highlight: true,
          labels: {
            buttonSkip: 'Terminar tour',
            buttonPrevious: 'Anterior',
            buttonNext: 'Siguiente',
            buttonStop: 'Terminar',
          }
        },
      steps: [
          {
            target: '[data-v-step="0"]',  // We're using document.querySelector() under the hood
            header: {
              title: 'Empieza tu recorrido',
            },
            content: `Agrega tu primer Expediente!`,
            params: {
              placement: 'auto'
            }
          },
          {
            target: '[data-v-step="1"]',
            content: 'Aquí puedes buscar entre tus Expedientes!',
            params: {
              placement: 'auto'
            }
          },
          {
            target: '[data-v-step="2"]',
            content: 'Aquí puedes ver tus Expedientes en forma de tabla!',
            params: {
              placement: 'top'             
            }
          },
          {
            target: '[data-v-step="3"]',
            content: 'Tus notificaciones configuradas!',
            params: {
              placement: 'auto'
            }
          },
          {
            target: '[data-v-step="4"]',
            content: 'Ver detalles de tu Expediente!',
            params: {
              placement: 'auto'             
            }
          },
          {
            target: '[data-v-step="5"]',
            content: 'Edita tu expediente!',
            params: {
              placement: 'auto'             
            }
          }
        ]
    };
  },
  computed: {
    ...mapGetters({ proceedings: 'stateProceedings' }),
    filteredProceedings() {
      if (!this.searchQuery) return this.proceedings;
      return this.proceedings.filter(p =>
        p.number.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        p.description.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    },
    paginatedProceedings() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredProceedings.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredProceedings.length / this.itemsPerPage);
    },
  },
  created() {
    return this.$store.dispatch('getProceedings', this.$store.state.users.user);
  },
  methods: {
    ...mapActions(['getProceedings']),
    refreshProceedings() {
      this.getProceedings();
      this.showAdd = false;
      this.showEdit = false;
      this.showView = false;
    },
    toggleView() {
      this.isTableView = !this.isTableView;
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },
    openAddModal() {
      this.showAdd = true;
    },
    openEditModal(id) {
      this.editId = id;
      this.showEdit = true;
      this.showView = false;
    },
    closeEditModal() {
      this.showEdit = false;
      this.editId = null;
    },
    openViewModal(id) {
      this.viewId = id;
      this.showView = true;
      this.showEdit = false;
    },
    closeViewModal() {
      this.showView = false;
      this.viewId = null;
    },
    startTour() {
      // Implementar si usas v-tour
        this.$tours['myTour'].start();

    },
  },
});
</script>

<style scoped>
.dashboard-container {
  max-width: 1100px;
  margin: 2.5rem auto;
  padding: 2rem 1.5rem;
  background: var(--background);
  border-radius: 24px;
  min-height: 600px;
  box-shadow: 0 2px 16px 0 rgba(0,0,0,0.04);
  border: 2px solid var(--primary);
}
.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}
.dashboard-title h1 {
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
  color: var(--primary);
}
.dashboard-actions {
  display: flex;
  gap: 1rem;
}
.toggle-btn, .add-btn, .help-btn {
  background: #fff;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 0.5rem 1.5rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.toggle-btn:hover, .add-btn:hover, .help-btn:hover {
  background: #f3eaff;
  color: var(--primary-dark);
}
.add-btn {
  background: var(--primary);
  color: #fff;
  border: none;
}
.add-btn:hover {
  background: var(--primary-dark);
}
.search-container {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 0.5rem 1rem;
  margin-bottom: 2rem;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.04);
}
.search-icon {
  color: var(--primary);
  margin-right: 0.7rem;
}
.search-input {
  border: none;
  outline: none;
  font-size: 1rem;
  background: transparent;
  flex: 1;
}
.cards-container {
  margin-top: 1.5rem;
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 1.5rem;
}
.proceeding-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.06);
  padding: 1.5rem 1.2rem;
  cursor: pointer;
  transition: box-shadow 0.2s;
}
.proceeding-card:hover {
  box-shadow: 0 4px 24px 0 rgba(162,89,230,0.13);
}
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}
.card-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--primary);
}
.card-badge {
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.badge-count {
  background: var(--primary);
  color: #fff;
  border-radius: 12px;
  padding: 0.2rem 0.7rem;
  font-size: 0.95rem;
  font-weight: 600;
}
.card-body {
  color: #222;
  font-size: 1rem;
}
.table-container {
  margin-top: 2rem;
}
.proceedings-table {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.04);
}
.proceedings-table th, .proceedings-table td {
  padding: 1rem 0.7rem;
  text-align: left;
}
.proceedings-table th {
  background: var(--primary);
  color: #fff;
  font-weight: 700;
}
.notification-badge {
  background: var(--primary);
  color: #fff;
  border-radius: 12px;
  padding: 0.2rem 0.7rem;
  font-size: 0.95rem;
  font-weight: 600;
}
.table-btn {
  background: #fff;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 0.3rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-right: 0.5rem;
  transition: background 0.2s, color 0.2s;
}
.table-btn:hover {
  background: #f3eaff;
  color: var(--primary-dark);
}
.empty-state {
  text-align: center;
  margin-top: 4rem;
}
.empty-state-icon {
  font-size: 3rem;
  color: var(--primary);
  margin-bottom: 1rem;
}
.empty-state-btn {
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 20px;
  padding: 0.7rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  margin-top: 1.5rem;
  cursor: pointer;
  transition: background 0.2s;
}
.empty-state-btn:hover {
  background: var(--primary-dark);
}
.pagination-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  margin-top: 2rem;
}
.pagination-btn {
  background: #fff;
  color: var(--primary);
  border: 2px solid var(--primary);
  border-radius: 20px;
  padding: 0.3rem 1rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}
.pagination-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination-btn:hover:not(:disabled) {
  background: #f3eaff;
  color: var(--primary-dark);
}
.pagination-info {
  font-size: 1rem;
  color: #222;
}
@media (max-width: 900px) {
  .dashboard-container {
    padding: 1.5rem 0.5rem;
  }
  .dashboard-header {
    flex-direction: column;
    gap: 1.2rem;
    align-items: flex-start;
  }
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
</style>
